import { Description, DirectionsBoat } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { changes, fields } from "src/components/utils/fields";
import { QuoteFormField } from "./QuoteFormField";

export const ServiceTypeDetails = ({ dataState, setDataState }) => {
  const { t } = useTranslation();

  const classOptions = [
    { label: t('Freight'), value: 'FRG' },
    { label: t('File Charges'), value: 'Fil' },
    { label: t('Warehousing'), value: 'War' },
    { label: t('Insurance'), value: 'Ins' },
    { label: t('Customs Brokerage'), value: 'Cus' },
    { label: t('Complaints'), value: 'Com' },
    { label: t('Third Party Costs'), value: 'Thi' },
    { label: t('Handlings'), value: 'HAN' },
    { label: t('Transport'), value: 'TRP' },
    { label: t('Rebates'), value: 'REB' },
    { label: t('Miscellaneous'), value: 'MSC' },
    { label: t('Agent Profits'), value: 'AGP' },
    { label: t('Disbursement'), value: 'DSB' },
  ];

  const formFields = [
    { display: t("ServiceCode"), required: true, code: "ServiceCode", type: "text" },
    { display: t("ServiceName"), required: true, code: "ServiceName", type: "text" },
    { display: t("Comments"), required: false, code: "Comments", type: "text" },
    {
      display: t('Class'),
      required: true,
      code: 'Class',
      type: 'select',
      options: classOptions,
      extraField: 'ClassValue',
    },
  ];

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <Description style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Details")}
          </div>
        }
        elements={
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {formFields.map((field, index) => <QuoteFormField fields={field} index={index} options={field?.options} data={dataState} setData={setDataState} />)}
          </div>
        }
      />
    </>
  );
};
